import { useState, useEffect } from 'react';
import {
  AgxLabel,
  AgxRow,
  AgxColumn,
  AgxRadio,
} from '@urbanx/agx-ui-components';
import { ErrorState } from 'types/Payable';
import InspectionOfRecords from './InspectionOfRecords';
import './BodyCorporateRecord.scss';
import {
  DepositPayable,
  FormCondition,
  FormConditionCondition,
  FormConditionDayType,
  SpecialConditionData,
} from '@urbanx/agx.campaigns.client';

interface BodyCorporateRecordProps {
  id: string;
  label?: string;
  onValueChanged: (change: { id: string; value: FormCondition }) => void;
  defaultValue: FormCondition;
  required?: boolean;
  validate?: boolean;
  error?: ErrorState;
  specialConditions: SpecialConditionData[];
  campaignId: string;
}

const BodyCorporateRecord = ({
  id,
  label,
  onValueChanged,
  defaultValue,
  required = false,
  validate,
  error,
  specialConditions,
  campaignId,
}: BodyCorporateRecordProps) => {
  const [bodyCorporateRecordCondition, setBodyCorporateRecordCondition] =
    useState<FormCondition>({
      ...defaultValue,
      condition:
        defaultValue?.condition ?? FormConditionCondition.NotApplicable,
    });
  useEffect(() => {
    onValueChanged({ id, value: bodyCorporateRecordCondition });
  }, [bodyCorporateRecordCondition]);

  return (
    <AgxColumn veryLargeGap fill extraClasses={'bodyCorporateRecordCondition'}>
      {label && (
        <AgxRow fill spaceBetween>
          <AgxLabel medium>{label}</AgxLabel>
        </AgxRow>
      )}
      <div className="agxRadio-group">
        <AgxRadio
          id="noBodyCorporateRecord"
          label="Not subject to Inspection of Records"
          onCheckChanged={() =>
            setBodyCorporateRecordCondition(prev => ({
              ...prev,
              condition: FormConditionCondition.NotApplicable,
              depositPayable: DepositPayable.NDaysFrom,
              dayType: FormConditionDayType.Days,
              other: undefined,
              daysFromDate: undefined,
              referenceDate: undefined,
              specialConditionId: undefined,
            }))
          }
          checked={
            bodyCorporateRecordCondition.condition ===
            FormConditionCondition.NotApplicable
          }
        />
        <AgxRadio
          id="yesBodyCorporateRecord"
          label="Subject to Inspection of Records"
          onCheckChanged={() =>
            setBodyCorporateRecordCondition(prev => ({
              ...prev,
              condition: FormConditionCondition.NdaysFromDate,
            }))
          }
          checked={
            bodyCorporateRecordCondition.condition !==
            FormConditionCondition.NotApplicable
          }
          subContent={
            bodyCorporateRecordCondition.condition !==
            FormConditionCondition.NotApplicable
              ? [
                  <InspectionOfRecords
                    id={id}
                    onValueChanged={({
                      value: bodyCorporateRecordConditionValue,
                    }) =>
                      setBodyCorporateRecordCondition(prev => ({
                        ...prev,
                        ...bodyCorporateRecordConditionValue,
                      }))
                    }
                    defaultValue={bodyCorporateRecordCondition}
                    validate={validate}
                    error={error}
                    required={required}
                    specialConditions={specialConditions}
                    campaignId={campaignId}
                  />,
                ]
              : undefined
          }
        />
      </div>
    </AgxColumn>
  );
};

export default BodyCorporateRecord;
